export default __webpack_public_path__ + "static/media/bannerDefault.f4be0ba5.png";